// Stub trendBuilder slice for PWP
import { createSlice } from '@reduxjs/toolkit';

const trendBuilderSlice = createSlice({
    name: 'trendBuilder',
    initialState: {
        activeTrendStats: [],
        activeTrendStatsLoading: false,
        userTrends: [],
        presetTrends: [],
    },
    reducers: {
        setPresetFilters(state, action) {
            // No-op in PWP
        },
        setActiveTrendStats(state, action) {
            state.activeTrendStats = action.payload;
        },
    },
});

export const { setPresetFilters, setActiveTrendStats } = trendBuilderSlice.actions;
export default trendBuilderSlice.reducer;
